"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("./Button.styles");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Button = /*#__PURE__*/_react.default.forwardRef(function (props, outerRef) {
  var isDisabled = props.isDisabled,
    children = props.children,
    ariaLabel = props.ariaLabel,
    ariaExpanded = props.ariaExpanded,
    ariaHaspopup = props.ariaHaspopup,
    role = props.role,
    onClick = props.onClick,
    onDisabledClick = props.onDisabledClick,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    category = props.category,
    label = props.label,
    optionalData = props.optionalData,
    id = props.id;
  var styles = (0, _Button.useStyles)(props);
  var _useCetEvents = (0, _hooks.useCetEvents)(),
    sendUiUsageEvent = _useCetEvents.sendUiUsageEvent;
  var handleClick = function handleClick(event) {
    if (!isDisabled) {
      if (category && label) {
        sendUiUsageEvent({
          category: category,
          label: label,
          optionalData: optionalData
        });
      }
      if (onClick) {
        onClick(event);
      }
    } else {
      if (onDisabledClick) {
        onDisabledClick(event);
      }
    }
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    if (!isDisabled) {
      if (onMouseEnter) {
        onMouseEnter(event);
      }
    }
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    if (!isDisabled) {
      if (onMouseLeave) {
        onMouseLeave(event);
      }
    }
  };
  var handleBlur = function handleBlur(event) {
    if (!isDisabled) {
      if (onBlur) {
        onBlur(event);
      }
    }
  };
  var handleFocus = function handleFocus(event) {
    if (!isDisabled) {
      if (onFocus) {
        onFocus(event);
      }
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (!isDisabled) {
      if (onKeyDown) {
        onKeyDown(event);
      }
    }
  };
  var handleKeyUp = function handleKeyUp(event) {
    if (!isDisabled) {
      if (onKeyUp) {
        onKeyUp(event);
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    "data-testid": id || null,
    ref: outerRef,
    role: role,
    className: styles['cc-Button'],
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    "aria-disabled": isDisabled,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": ariaHaspopup,
    children: children
  });
});
exports.Button = Button;